import {
  Button,
  Dialog,
  DialogClose,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@porchpass/ui";
import { useState } from "react";

interface CreateApplicationDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  borrowerName: string;
  onConfirm: () => Promise<void>;
}

export default function DuplicateBorrowerConfirmationDialog({
  open,
  onOpenChange,
  borrowerName,
  onConfirm,
}: CreateApplicationDialogProps) {
  const [isLoading, setIsLoading] = useState(false);

  const handleConfirm = async () => {
    setIsLoading(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } catch {
      // Parent throws to keep dialog open (e.g. retryable 5xx).
      // Toast is fired by the parent; we just stay open.
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-[440px] rounded-[20px] p-0 gap-0">
        <DialogHeader className="border-b border-[#e4e7ec] px-6 py-4">
          <DialogTitle className="text-base font-semibold text-[#111827]">
            Duplicate borrower
          </DialogTitle>
        </DialogHeader>
        <div className="px-6 py-6">
          <p className="text-base font-medium text-[#111827]">
            <>
              <span className="font-semibold">{borrowerName}</span> already has
              an application in progress. Are you sure you would like to create
              another?
            </>
          </p>
        </div>
        <DialogFooter className="gap-4 justify-end px-6 pt-0 pb-6">
          <DialogClose asChild>
            <Button variant="ghost" size="s" disabled={isLoading}>
              Cancel
            </Button>
          </DialogClose>
          <Button
            variant="primary"
            size="s"
            onClick={() => void handleConfirm()}
            innerClassName="gap-2"
            loading={isLoading}
            disabled={isLoading}
          >
            Confirm
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
